<template>
  <div style="background-color: #27b03e;padding-bottom: 10vw">
    <div style="font-size: 0;">
      <img src="@/assets/bank-img/1.png" style="width: 100%;"/>
      <img src="@/assets/bank-img/2.png" style="width: 100%;"/>
      <img src="@/assets/bank-img/3.png" style="width: 100%;"/>
      <img src="@/assets/bank-img/4.png" style="width: 100%;"/>
      <img src="@/assets/bank-img/5.png" style="width: 100%;"/>
      <img src="@/assets/bank-img/6.png" style="width: 100%;"/>
    </div>
    <div class="q_btn" @click="download">去认证</div>
  </div>
</template>

<script>
import {getLoginUser} from "@/api/login";
import {Dialog} from "vant";
import {bankAuthPay} from "@/api/pay";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: "download",
  data() {
    return {}
  },
  created() {
    wxCloseShare()
    var isPageHide = false;
    window.addEventListener('pageshow', function () {
      if (isPageHide) {
        window.location.reload();
      }
    });
    window.addEventListener('pagehide', function () {
      isPageHide = true;
    });
    getLoginUser().then(res => {
      if (res.data.isBankAuth == '1') {
        this.$router.push({
          path: '/'
        });
      }
    })
  },
  methods: {
    download() {
      Dialog.confirm({
        title: '提示',
        message: '您是否已经安装中国农业银行掌银APP？',
        confirmButtonText: '我已安装',
        cancelButtonText: '去下载',
      }).then(() => {
        // on confirm
        this.$modal.loading('跳转中')
        bankAuthPay().then(res => {
          if (res.payUrl != '' && res.payUrl != null) {
            window.location.href = res.payUrl
          }
        })
      }).catch(() => {
        // on cancel
        // window.location.href = "https://enjoy.abchina.com/bleeze/ctc-view/#/bankActivityHdo?sign=2f2fe5e17ece0f7c1bef28e15c5b03205d28736d2dc7978a0645e9a26ba1a8d03e4a31fa4675e66258d7ff6d5d24ed96f73b70613ed2d6de8db65937a5db78838e3e051193543f1caeab96ecbfb5e7f9a058b76b354405571ad43e47e1ee3d1f"

        window.location.href = "https://mmsp.abchina.com/paas-prod-mmsp-bs/custpage/mbankdownload/R3hzcE1ZTW40RlFOYTcxSGd1L0gzN1p0bUdMYWZzV0RKakJOWWhqQmcydXlmOTFYOS9WaTlBPT0"

      });


    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.q_btn {
  background-color: #feb300;
  color: #ffffff;
  width: 60%;
  margin: 0 0 0vw 20%;
  height: 12vw;
  line-height: 12vw;
  text-align: center;
  border-radius: 6vw;
  box-shadow: 0 0 2vw #feb300;
  font-weight: 700;
  font-size: 4.2vw;
  letter-spacing: .2vw;
}
</style>
